import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import BASE_URL from "../../services/api";

function Causes() {
  const [causes, setCauses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BASE_URL}/causes/published`) // ✅ FIXED ROUTE
      .then((res) => {
        if (!res.ok) throw new Error("Server error");
        return res.json();
      })
      .then((data) => {
        console.log("Published causes:", data);
        setCauses(data);
        setLoading(false);
      })
      .catch(() => {
        alert("Failed to load causes");
        setLoading(false);
      });
  }, []);

  // ✅ SAFE IMAGE PATH HANDLER
  const getImageUrl = (image) => {
    if (!image) return "/placeholder.png";
    if (image.startsWith("http")) return image;
    if (image.startsWith("uploads")) return `${BASE_URL}/${image}`;
    return `${BASE_URL}/uploads/images/${image}`;
  };

  return (
    <div style={{ display: "flex" }}>
      <div className="page-content">
        <h2 className="live-causes-title">Live Causes</h2>

        {loading ? (
          <p>Loading...</p>
        ) : causes.length === 0 ? (
          <p style={{ color: "#aaa" }}>No causes available</p>
        ) : (
          <div className="cause-grid">
            {causes.map((cause) => (
              <div className="cause-card" key={cause.id}>
                <img
                  src={getImageUrl(cause.image)}
                  alt={cause.title}
                  className="cause-image"
                  onError={(e) => {
                    e.target.src = "/placeholder.png";
                  }}
                />

                <div className="cause-body">
                  <p className="cause-category">{cause.category}</p>
                  <h3 style={{ color: "#1b2a1b" }}>{cause.title}</h3>
                  <p className="cause-amount" style={{ color: "#2e7d32" }}>
                    ₹{Number(cause.amount_required).toLocaleString()}
                  </p>

                  <Link to={`/causes/${cause.id}`}>
                    <button className="view-btn">View Details</button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Causes;
